import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-forgot-password-step',
  templateUrl: './forgot-password-step.component.html',
  styleUrls: ['./forgot-password-step.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class ForgotPasswordStepComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() contact = '';
  @Input() isLoading = false;
  @Input() errorText = '';

  isPasswordVisible = false;
  isConfirmPasswordVisible = false;

  @Output() submitted = new EventEmitter<void>();
  @Output() resent = new EventEmitter<void>();
  @Output() backed = new EventEmitter<void>();
}
